import * as React from "react";

type ClickEvent<ElementType> = React.MouseEvent<ElementType, MouseEvent>;
type EventListener<EventType> = (event: EventType) => void;

export interface ActionButtonBackupProps {
  text: string;
  onClick?: EventListener<ClickEvent<HTMLElement>>;
  disabled?: boolean;
  styles?: React.CSSProperties;
  testId?: string;
}

export const ActionButtonBackup: React.FunctionComponent<ActionButtonBackupProps> = (
  props
) => {
  const { onClick, text, disabled, styles, ...remainingProps } = props;
  return (
    <div
      onClick={onClick}
      style={{
        background: disabled ? "#AAA" : "#FFF",
        borderStyle: "solid",
        borderWidth: 1,
        padding: "8px 12px 8px 12px",
        cursor: "pointer",
        ...styles,
      }}
      {...remainingProps}
    >
      {text}
    </div>
  );
};
